import {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_OCCASION_DEFAULTS,
} from '../jewelry/bespokeFormOptionDefaults';

export function slugifyBespokeOptionValue(label) {
  return String(label || '')
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 48);
}

/** @param {unknown} raw @param {{ value: string, label: string }[]} defaults */
export function normalizeBespokeFormOptionsList(raw, defaults) {
  const fallback = Array.isArray(defaults) ? defaults : [];
  if (!Array.isArray(raw) || raw.length === 0) {
    return fallback.map((item) => ({ ...item }));
  }

  const out = [];
  const seen = new Set();

  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    let label = String(item.label ?? '').trim();
    let value = String(item.value ?? '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, '');

    if (!label && value) {
      label = value.replace(/-/g, ' ');
    }
    if (!label) continue;

    if (!value) {
      value = slugifyBespokeOptionValue(label);
    }
    if (!value || seen.has(value)) continue;

    seen.add(value);
    out.push({ value, label });
  }

  return out.length > 0 ? out : fallback.map((item) => ({ ...item }));
}

export function normalizeBespokeOccasions(raw) {
  return normalizeBespokeFormOptionsList(raw, BESPOKE_OCCASION_DEFAULTS);
}

export function normalizeBespokeJewelryTypes(raw) {
  return normalizeBespokeFormOptionsList(raw, BESPOKE_JEWELRY_TYPE_DEFAULTS);
}

/** @param {unknown} raw @param {{ icon: string, title: string, text: string }[]} defaults */
export function normalizeCustomJewelryTrustItems(raw, defaults) {
  const fallback = Array.isArray(defaults) ? defaults.map((item) => ({ ...item })) : [];
  if (!Array.isArray(raw) || raw.length === 0) {
    return fallback;
  }

  const out = [];
  for (const item of raw.slice(0, 4)) {
    if (!item || typeof item !== 'object') continue;
    const title = String(item.title ?? '').trim();
    const text = String(item.text ?? '').trim();
    const icon = String(item.icon ?? '·').trim() || '·';
    if (!title) continue;
    out.push({ icon, title, text: text || title });
  }

  return out.length > 0 ? out : fallback;
}

/** @param {unknown} raw @param {{ text: string }[]} defaults */
export function normalizeCustomJewelrySteps(raw, defaults) {
  const fallback = Array.isArray(defaults) ? defaults.map((item) => ({ ...item })) : [];
  if (!Array.isArray(raw) || raw.length === 0) {
    return fallback;
  }

  const out = [];
  for (const item of raw.slice(0, 5)) {
    if (!item || typeof item !== 'object') continue;
    const text = String(item.text ?? '').trim();
    if (!text) continue;
    out.push({ text });
  }

  return out.length > 0 ? out : fallback;
}
